<template>
  <div class="center">
    <div style="display: flex; align-items: center; margin: 20px 0">
      <el-input
        style="width: 220px; margin-right: 10px"
        placeholder="请输入公告关键字"
        prefix-icon="el-icon-search"
        clearable
        v-model="queryParams.title"
      >
      </el-input>
      <el-date-picker
        style="margin-right: 10px"
        v-model="queryParams.expiryTimeStart"
        value-format="yyyy-MM-dd HH:mm:ss"
        type="date"
        placeholder="开始日期"
      >
      </el-date-picker>
      <el-date-picker
        style="margin-right: 10px"
        v-model="queryParams.expiryTimeEnd"
        value-format="yyyy-MM-dd"
        type="date"
        placeholder="结束日期"
      >
      </el-date-picker>
      <el-select
        v-model="queryParams.openStatus"
        placeholder="公告状态"
        clearable
        style="margin-right: 10px"
      >
        <el-option
          v-for="item in options"
          :key="item.value"
          :label="item.label"
          :value="item.value"
        >
        </el-option>
      </el-select>
      <el-button type="primary" icon="el-icon-search" @click="handleQuery"
        >搜索</el-button
      >
    </div>
    <el-table
      :data="purchaseList"
      style="width: 100%"
      fit
      v-loading="loading"
      @row-click="rowClick"
    >
      <el-table-column
        prop="title"
        label="采购编号"
        align="center"
        show-overflow-tooltip
        class-name="column-title"
      >
      </el-table-column>
      <el-table-column label="公告状态" width="300" align="center">
        <template slot-scope="{ row }">
          <span v-if="row.openStatus == 0" style="color: #409eff">未成交</span>
          <span v-else-if="row.openStatus == 1" style="color: #67c23a"
            >已成交</span
          >
          <span v-else-if="row.openStatus == 5" style="color: #e6a23c"
            >已中止</span
          >
          <span v-else-if="row.openStatus == 2" style="color: #f56c6c"
            >已终止</span
          >
        </template>
      </el-table-column>

      <el-table-column label="截止时间" width="300" align="center">
        <template slot-scope="{ row }">
          <span>{{ parseTime(row.expiryTime, "{y}-{m}-{d}") }}</span>
        </template>
      </el-table-column>
    </el-table>
    <div style="text-align: right">
      <pagination
        v-show="total > 0"
        :total="total"
        :page.sync="queryParams.pageNum"
        :limit.sync="queryParams.pageSize"
        @pagination="getList"
        :autoScroll="false"
      />
    </div>
  </div>
</template>
  
<script>
import {
  getNoticeList,
  getPurchaseList,
  getSupplierList,
  getRNoticeList,
} from "@/api/home";
export default {
  name: "caigou",
  data() {
    return {
      loading: false,
      options: [
        {
          label: "未成交",
          value: "0",
        },
        {
          label: "已成交",
          value: "1",
        },
        {
          label: "已终止",
          value: "2",
        },
        // {
        //   label: "已中止",
        //   value: "5",
        // },
      ],
      queryParams: {
        pageNum: 1,
        pageSize: 10,
        title: "",
        expiryTimeStart: "",
        expiryTimeEnd: "",
        openStatus: "",
      },
      purchaseList: [],
      total: 0,
    };
  },
  mounted() {
    this.getList();
  },
  methods: {
    rowClick(row) {
      this.$emit("rowClick", row);
      // window.open("/#/detail?id=" + row.id, "采购公告");
    },
    getList() {
      this.loading = true;
      if (this.queryParams.expiryTimeEnd) {
        if (this.queryParams.expiryTimeEnd.indexOf("23:59:59") > -1) {
        } else {
          this.queryParams.expiryTimeEnd =
            this.queryParams.expiryTimeEnd + " 23:59:59";
        }
      }
      getPurchaseList(this.queryParams).then((res) => {
        this.purchaseList = res.rows;
        this.total = res.total;
        this.loading = false;
      });
    },
    handleQuery() {
      this.queryParams.pageNum = 1;
      this.getList();
    },
  },
};
</script>

  